import Vue from 'vue';
import App from './App.vue';
import i18n from './modules/locale';
import Lodash from 'lodash';
import VueCookies from 'vue-cookies';
import VueScrollactive from 'vue-scrollactive';
// import VueAnalytics from 'vue-analytics';
import axios from 'axios';
import router from './modules/router';
import './registerServiceWorker';

Vue.config.productionTip = true;

Vue.prototype.$cdnUrl = process.env.VUE_APP_CDN_URL;
Vue.prototype.$mainUrl = process.env.VUE_APP_BASE_URL;

Vue.prototype.$utmTags = window.location.search;

Vue.prototype.$lodash = Lodash;
Vue.prototype.$axios = axios;

// social links
Vue.prototype.$socialLinks = {
  facebook: process.env.VUE_APP_SOCIAL_LINK_FACEBOOK,
  vkontakte: process.env.VUE_APP_SOCIAL_LINK_VKONTAKTE,
  twitter: process.env.VUE_APP_SOCIAL_LINK_TWITTER,
  instagram: process.env.VUE_APP_SOCIAL_LINK_INSTAGRAM,
  telegram: process.env.VUE_APP_SOCIAL_LINK_TELEGRAM,
  discord: process.env.VUE_APP_SOCIAL_LINK_DISCORD,
  youtube: process.env.VUE_APP_SOCIAL_LINK_YOUTUBE,
}

// Vue.use
Vue.use(VueCookies);
Vue.use(VueScrollactive);


// Vue.use(VueAnalytics, {
//   id: process.env.VUE_APP_ANALYTICS_ID
// });

// eslint-disable-next-line no-unused-vars
const vm = new Vue({
  el: '#app',
  i18n,
  router,
  render: h => h(App),
  components: {
    App
  },
  template: '<App/>'
});
